import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

import { Link } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { connect } from 'react-redux';

import { Container, ContainerInner, Header, Content } from './Layout.styles';

const history = createHistory();

const styles = theme => ({
  root: {
    marginTop: theme.spacing(3),
    width: '100%'
  },
  flex: {
    flex: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  }
});

class Layout extends Component {
  render() {
    const { classes, header, alpha, queryString, noBack, customCloseAction } = this.props;
    return (
      <Container alpha={alpha}>
        <Scrollbars
          onScroll={this.handleScroll}
          onScrollFrame={this.handleScrollFrame}
          onScrollStart={this.handleScrollStart}
          onScrollStop={this.handleScrollStop}
          onUpdate={this.handleUpdate}
          renderView={this.renderView}
          renderTrackHorizontal={this.renderTrackHorizontal}
          renderTrackVertical={this.renderTrackVertical}
          renderThumbHorizontal={this.renderThumbHorizontal}
          renderThumbVertical={this.renderThumbVertical}
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          height={'100%'}
          thumbMinSize={30}
          universal={true}
        >
          <AppBar position="fixed">
            <Toolbar>
              <Header className={classes.flex}>{header}</Header>
              {customCloseAction ? (
                <IconButton color="inherit" aria-label="close" onClick={customCloseAction}>
                  <CloseIcon />
                </IconButton>
              ) : (
                <Link to={`/${queryString}`}>
                  <IconButton color="inherit" aria-label="close">
                    <CloseIcon />
                  </IconButton>
                </Link>
              )}
            </Toolbar>
          </AppBar>
          <ContainerInner>
            <Content>
              {!noBack && (
                <Button
                  onClick={() => history.goBack()}
                  className={classes.button}
                  variant="contained"
                  color="secondary"
                >
                  <ArrowBackIcon className={this.props.classes.leftIcon} />
                  Cofnij
                </Button>
              )}
              <br />
              <br />
              {this.props.children}
            </Content>
          </ContainerInner>
        </Scrollbars>
      </Container>
    );
  }
}

const mapStateToProps = ({ ro: { mapType, date, currentLocation, queryString } }) => ({
  mapType,
  date,
  currentLocation,
  queryString
});

export default connect(mapStateToProps)(withStyles(styles)(Layout));
